import { formatDataPatternToCalendar } from 'components/dashboard/product-template-table/utils/utils';
import { Calendar, CalendarChangeParams } from "primereact/calendar";
import React, { FormEvent, useEffect, useState } from 'react';
import { addLeadingZeros } from 'utils/utils';
import { DEFAULT_DATE_PATTERN } from 'utils/constants';
import { IDateTimeProps } from "../../../utils/cellInterfaces";

export default function DateTime(props: IDateTimeProps) {
    const [date, setDate] = useState<Date | undefined>(props.value ? convertStringToDate(props.value) : undefined);
    const [onCalendarFocus, setOnCalendarFocus] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        if (onCalendarFocus === false && date) {
            props.changeHandler(convertDateToString(date))
        }
    }, [onCalendarFocus]);

    function convertStringToDate(value: string) {
        if (value) {
            return new Date(Date.parse(value));
        } 
            return undefined;
        
    }

    const hasHours = () => {
        let has = true;
        if (props.format) {
            has = props.format.split(' ')[1] !== undefined;
        }
        return has;
    }

    const convertDateToString = (d: Date): string => {
        const year = d.getFullYear();
        const month = addLeadingZeros(d.getMonth() + 1, 2);
        const day = addLeadingZeros(d.getDate(), 2);
        const hours = addLeadingZeros(d.getHours(), 2);
        const minutes = addLeadingZeros(d.getMinutes(), 2);
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    }

    const dateChangeHandler = (e: CalendarChangeParams) => {
        if (e.value) {
            setDate(e.value as Date);
            props.changeHandler(convertDateToString(e.value as Date)) 
        }
    }

    const displayValue = () => {
        // if format has hours
        if (hasHours()) {
            return props.value;
        }
        return props.value.split(' ')[0];
    }
    const dateFormat = formatDataPatternToCalendar(props.format ?? DEFAULT_DATE_PATTERN)?.split(" ")[0]

    if (props.isInEditMode) {
        return <Calendar showTime={hasHours()}
                         hourFormat="24"
                         value={date}
                         onChange={dateChangeHandler}
                         dateFormat={dateFormat}
                         stepMinute={5}
                         onFocus={() => setOnCalendarFocus(true)}
                         onHide={() => setOnCalendarFocus(false)}
                         onInput={(e: FormEvent<HTMLInputElement>) => {
                             const val = e.target as HTMLInputElement;
                             if (!val.value) {
                                 setDate(undefined);
                                 props.changeHandler(undefined)
                             }
                         }}
        />
        // TODO add formatter converter
    } 
        return <div className="p-inputtext"
                    style={{border: 'none', backgroundColor: 'transparent', color: "inherit", whiteSpace: "pre-wrap"}}>
            {
                props.value ? (displayValue().replaceAll('-', '-\u2060')) : ("N/A")
            }
        </div>
    
}